export enum AgreementOpenBeforeEvent {
  CODE_DOWNLOAD = 1,
}
